import Link from 'next/link'
import React, { type ReactNode } from 'react'

import HedepyLogo from '../HedepyLogo'

type Props = {
  href?: string
  className?: string
  logo?: ReactNode
}

const HomepageButton: React.FC<Props> = ({ href = '/', className = '', logo }) => {
  return <Link href={href}>{logo ?? <HedepyLogo className={className} />}</Link>
}

export default HomepageButton
